import React, { useEffect, useState } from 'react'

import { getSegments } from '../services'
import { handleError } from '../../../helpers'

export default function SegmentsSelect({ setSegmentFilters, reload }) {
	const [segments, setSegments] = useState(null)

	useEffect(() => {
		!segments && getSegments({
			'filter[visible]': 1,
			'filter[active]': 1,
			include: 'scopes',
		})
			.then(res => setSegments(res.data.data))
			.catch(error => handleError(error))
	}, [ segments ])

	const handleChange = e => {
		const selectedSegment = segments.find(segment => segment.id === parseInt(e.target.value))
		setSegmentFilters(parseParams(getSegmentParams(selectedSegment)))
		reload()
	}

	return (
		<React.Fragment>
			<div className='mb-2'>
				<select className="form-control" onChange={handleChange}>
					<option value="">:: Todos los clientes ::</option>
					{segments && segments.map(segment => (
						<option key={segment.id} value={segment.id}>
							Segmento #{segment.id} - {segment.name}
						</option>
					))}
				</select>
			</div>
		</React.Fragment>
	)
}

const getSegmentParams = (segment) => {
	return {
		filters:[
			...segment.scopes.map(s => ({
				type: s.query_key,
				value: `${s.pivot.value ? s.pivot.value : 'true'}${s.pivot.operator ? `,${s.pivot.operator}` : ''}`
			}))
		],
		sort: '-created_at'
	}
}

export const parseParams = (params) => {
	let query = {}

	params.filters.forEach((filter) => {
		query[`filter[${filter.type}]`] = filter.value
	})

	if(params.scope){
		query[`filter[${params.scope}]`] = 1
	}

	if(params.sort){
		query['sort'] = params.sort
	}

	return query
}